<div class="">
    <!-- Header -->
    <div class="">
        <div class="flex sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0">
            <h2 class="text-xl md:text-2xl font-bold text-gray-900">Transaction History</h2>
            <div class="flex gap-2 md:gap-3">
                <!-- <button (click)="refreshTransactions()" [disabled]="isLoading" class="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-3 md:px-4 py-2 rounded-lg font-medium hover:from-amber-600 hover:to-amber-700 transition-all flex items-center gap-2 text-sm md:text-base">
                    <i-lucide name="refresh-ccw" class="h-4 w-4"></i-lucide>
                    <span class="hidden sm:inline">Refresh</span>
                </button> -->
                <button (click)="onExport()" class="cursor-pointer bg-gray-100 text-gray-700 px-3 md:px-4 py-2 rounded-lg font-medium hover:bg-gray-200 transition-all flex items-center gap-2 text-sm md:text-base">
                    <i-lucide name="download" class="h-4 w-4"></i-lucide>
                    <span class="hidden sm:inline">Export</span>
                </button>
            </div>
        </div>
    </div>

    <!-- Table Content -->
    <div class="overflow-hidden mt-4 md:mt-6">

        <!-- Loading State -->
        <div *ngIf="isLoading" class="flex items-center justify-center py-8 md:py-12">
            <div class="text-center">
                <div class="animate-spin rounded-full h-8 w-8 md:h-12 md:w-12 border-b-2 border-amber-500 mx-auto mb-4"></div>
                <p class="text-gray-600 text-sm md:text-base">Loading transactions...</p>
            </div>
        </div>

        <!-- Error State -->
        <div *ngIf="error && !isLoading && !isAuthenticated" class="p-6 md:p-12 text-center">
            <i-lucide name="alert-circle" class="h-8 w-8 md:h-12 md:w-12 text-red-500 mx-auto mb-4"></i-lucide>
            <h3 class="text-base md:text-lg font-semibold text-gray-900 mb-2">Authentication Required</h3>
            <p class="text-gray-600 mb-4 text-sm md:text-base">{{ error }}</p>
            <button (click)="refreshTransactions()" class="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-4 py-2 rounded-lg font-medium hover:from-amber-600 hover:to-amber-700 transition-all text-sm md:text-base">
                Check Login Status
            </button>
        </div>

        <!-- Transactions Table -->
        <div *ngIf="!isLoading && !error">
            <!-- Desktop Table -->
            <div class="overflow-x-auto">
                <p-table [value]="transactions" [paginator]="true" [rows]="rows" [totalRecords]="totalItems" [rowsPerPageOptions]="rowsPerPageOptions" (onLazyLoad)="onPageChange($event)" styleClass="clean-table">

                    <!-- Table Header -->
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="p-3 lg:p-4 text-left">Portfolio</th>
                            <th class="p-3 lg:p-4 text-right">Amount</th>
                            <th class="p-3 lg:p-4 text-center ">Tickets</th>
                            <th class="p-3 lg:p-4 text-center">Status</th>
                            <th class="p-3 lg:p-4 text-center">Processed Date</th>
                            <th class="p-3 lg:p-4 text-center">Transaction ID</th>
                            <th class="p-3 lg:p-4 text-center">Actions</th>
                        </tr>
                    </ng-template>

                    <!-- Table Body -->
                    <ng-template pTemplate="body" let-transaction>
                        <tr>
                            <!-- Portfolio -->
                            <td class="p-3 lg:p-4">
                                <div>
                                    <div class="font-medium text-gray-900 text-sm lg:text-base">
                                        {{ transaction.portfolioId?.name || 'N/A' }}
                                    </div>
                                    <div class="text-xs lg:text-sm text-gray-500">
                                        {{ transaction.transactionType }}
                                    </div>
                                </div>
                            </td>

                            <!-- Amount -->
                            <td class="p-3 lg:p-4 text-right">
                                <div class="font-semibold text-gray-900 text-sm lg:text-base">
                                    {{ formatCurrency(transaction.amount) }}
                                </div>
                            </td>

                            <!-- Tickets -->
                            <td class="p-3 lg:p-4 text-center">
                                <span class="text-sm lg:text-base">
                                    {{ transaction.ticketsPurchased }}
                                </span>
                            </td>

                            <!-- Status -->
                            <td class="p-3 lg:p-4 text-center">
                                <span class="inline-flex items-center px-2 lg:px-2.5 py-0.5 rounded-full text-xs font-medium" [ngClass]="{
                                        'bg-yellow-100 text-yellow-800': transaction.status === 'Pending',
                                        'bg-green-100 text-green-800': transaction.status === 'Approved',
                                        'bg-red-100 text-red-800': transaction.status === 'Rejected'
                                      }">
                                    <i-lucide [name]="getStatusIcon(transaction.status)" class="h-3 w-3 mr-1"></i-lucide>
                                    {{ transaction.status }}
                                </span>
                            </td>

                            <!-- Date -->
                            <td class="p-3 lg:p-4 text-center">
                                <div class="text-xs lg:text-sm text-gray-900">
                                    {{ formatDate(transaction.processedAt) }}
                                </div>
                            </td>

                            <!-- Transaction ID -->
                            <td class="p-3 lg:p-4 text-center">
                                <div class="flex items-center justify-center gap-1 lg:gap-2">
                                    <code class="bg-gray-100 px-1.5 lg:px-2 py-1 rounded text-xs font-mono text-gray-600">
                                        {{ transaction._id.substring(0, 8) }}...
                                    </code>
                                    <button (click)="copyToClipboard(transaction._id)" class="text-gray-400 hover:text-gray-600 p-1 rounded cursor-pointer" pTooltip="Copy full transaction ID">
                                        <i-lucide name="copy" class="h-3 w-3"></i-lucide>
                                    </button>
                                </div>
                            </td>

                            <!-- Actions -->
                            <td class="p-3 lg:p-4 text-center">
                                <div class="flex items-center justify-center gap-1">
                                    <button *ngIf="transaction.status === 'Pending'" 
                                            (click)="cancelTransaction(transaction._id, $event)"
                                            class="text-red-500 hover:text-red-700 p-1.5 rounded-full hover:bg-red-50 transition-colors"
                                            pTooltip="Cancel Transaction"
                                            [disabled]="isLoading">
                                        <i-lucide name="circle-x" class="h-6 w-6"></i-lucide>
                                    </button>
                                    <span *ngIf="transaction.status !== 'Pending'" class="text-gray-400 text-xs">
                                        N/A
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                    <!-- Empty Message -->
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="6" class="p-8 lg:p-12" style="text-align: center;">
                                <!-- <i-lucide name="receipt" class="h-8 w-8 lg:h-12 lg:w-12 text-gray-400 mx-auto mb-4"></i-lucide> -->
                                <span class="text-base lg:text-lg font-medium text-gray-900 mb-2 text-center">No Transactions Found</span>
                                <p class="text-gray-500 text-sm lg:text-base">
                                    You haven't made any investments yet
                                </p>
                            </td>
                        </tr>
                    </ng-template>

                    <!-- Loading Template -->
                    <ng-template pTemplate="loadingbody">
                        <tr>
                            <td colspan="6" class="p-8 lg:p-12 text-center">
                                <div class="animate-spin rounded-full h-6 w-6 lg:h-8 lg:w-8 border-2 border-amber-500 border-t-transparent mx-auto mb-3"></div>
                                <p class="text-gray-600 text-sm lg:text-base">Loading transactions...</p>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>


        </div>
    </div>
</div>

<!-- Toast Messages -->
<p-toast position="top-right" [life]="4000"></p-toast>

<!-- Confirmation Dialog -->
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" acceptButtonStyleClass="bg-gradient-to-r from-amber-500 to-amber-600 border-amber-500 text-white" rejectButtonStyleClass="border-gray-300 text-gray-700">
</p-confirmDialog>